export default __webpack_public_path__ + "static/media/NFD_Minting_Guide1024_4.b2dc81ab.png";